export const onNoteChanged = (applicant, noteDetails) => {
    let _applicant = JSON.parse(JSON.stringify(applicant));
    _applicant.AdminNote.Data = noteDetails.note;
    if (!_applicant.StatusLogs) {
        _applicant.StatusLogs = [];
    }
    _applicant.StatusLogs.push(noteDetails.log);
    return _applicant;
};